import React from 'react';
import { Form, Button, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

const DetalleNivelCF = props => {
  return (
    <option style={props.styles.input} value={props.elemento._id}>{props.elemento.cicloFact}</option>
  )
};

const ListaCF = ({styles, handleLista, list}) => {
  const NivelDetalleES = list.map((elemento, _id) => <DetalleNivelCF styles={styles} elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select style={styles.input} className="ui simple selection dropdown fluid" name="cicloFact" id="miListaCF" onChange={handleLista}>
        <option style={styles.input} value="">Seleccionar...</option>
        {NivelDetalleES}
      </select>
    </div>
  )
};
const AddTar2 = ({styles, handleSubmit, handleChange, args, errors, comoAsigCicloFact, list8, handleLista}) => {
  const actInact = false
// console.log(comoAsigCicloFact)
  return(
    <div>
      <button className="ui right labeled icon button" style={styles.titBuscar}>
        <i className="large plus yellow icon"></i>
        Tarifa nueva
      </button>
      <div style={styles.box}>
        <Form onSubmit={(ev)=>handleSubmit(ev, args)}>
          <div className="ui one column stackable grid">
            <div className="row container">
              <div className="column" width="100%">
                <Form.Field>
                  <label style={styles.label}>Código</label>
                  <Form.Input autoComplete="off" name="codigoTarifa" id="codigoTarifa" onChange={handleChange} placeholder='Código' icon={!errors.length?null: _find(errors, {path:'codigoTarifa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                <Form.Field>
                  <label style={styles.label}>Descripción</label>
                  <Form.Input autoComplete="off" name="descrTarifa" id="descrTarifa" onChange={handleChange} placeholder='Descripción' icon={!errors.length?null: _find(errors, {path:'descrTarifa'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field>
                {comoAsigCicloFact==="Asignarlo a una tarifa y automáticamente al cliente cuando se le asigne tarifa" &&
                <Form.Field>
                  <label style={styles.label}>Ciclo de facturación</label>
                  <ListaCF list={list8} styles={styles} handleLista={handleLista} />
                </Form.Field>
                }
                <Form.Field>
                  <label style={styles.label}>Inactiva / Activa</label>
                  <Form.Checkbox defaultChecked={actInact} name="estadoTarifa" id="estadoTarifa" className='ui fitted toggle checkbox' onChange={handleChange}/>
                </Form.Field>

                <Button style={styles.confirmar} type='submit' fluid>
                  AGREGAR
                </Button>

                {
                  errors.length?<Message negative header="Los siguientes errores:"
                  list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>
          </div>
        </Form>
      </div>
    </div>
  )
}

export default AddTar2
